// src/components/AddMovimiento.jsx
import React from "react";
import AddMovimientoForm from "./AddMovimientoForm";

const AddMovimiento = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show); // el useEffect de Movimientos.jsx manejará el CSS global
  };
  return (
    <>
      <div>
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Movimiento"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          {/* 👇 clase clave para el CSS de visibilidad */}
          <div className="mov-form">
            <AddMovimientoForm setShow={setShow} />
          </div>
        </div>
      )}
    </>
  );
};
export default AddMovimiento;
